/* eslint-disable no-unused-vars */
import React from 'react';
import { useMediaQuery } from 'hooks';
import { ProjectMobile } from 'page/Project/mobile/ProjectMobile';
import { ProjectDesktop } from './Project/desktop/ProjectDesktop';

export default () => {
  const isDesktopOrLaptop = useMediaQuery();
  return (
    <>
      {!isDesktopOrLaptop && <ProjectMobile />}
      {isDesktopOrLaptop && <ProjectDesktop />}
    </>
  );
};
